export { default } from './hotjar-feedback-widget';
